import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const ChargeSchema = z
	.object({
		id: z.number().optional(),
		chargeName: z.string().min(1, 'This field is required'),
		isTax: z.boolean(),
		transSummaryField: z.string().nullable(),
		isExpired: z.boolean().optional(),
	})
	.superRefine((data, ctx) => {
		if (data.isTax && !data.transSummaryField) {
			ctx.addIssue({
				path: ['transSummaryField'],
				code: z.ZodIssueCode.custom,
				message: 'TransSummary Field is required when Tax is checked',
			});
		}
	});

export type Charge = z.infer<typeof ChargeSchema>;

export const all = async (
	pagination: PaginationState,
	sorting: SortingState = [],
	params: object,
): Promise<{ data: Charge[]; total: number }> => {
	try {
		let queryString = '';
		if (params) {
			const paramsAsString = JSON.stringify(params)
				.replace(/:/g, '=')
				.replace(/,/g, '&')
				.replace(/[{}"]/g, '');

			const searchParams = new URLSearchParams(paramsAsString);
			if (pagination) {
				searchParams.append('pageSize', pagination.pageSize.toString());
				searchParams.append('pageIndex', pagination.pageIndex.toString());
			}

			if (sorting.length > 0) {
				searchParams.append('sortBy', sorting[0].id);
				searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
			}

			queryString = `?${searchParams.toString()}`;
		}

		const response = await fetch(`/Charge${queryString}`);

		return await response.json();
	} catch (err) {
		return {
			data: [],
			total: 0,
		};
	}
};

export const add = async (charge: Charge): Promise<boolean> => {
	const res = await fetch(`/Charge`, {
		method: 'POST',
		body: JSON.stringify(charge),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};

export const update = async (
	charge: Charge,
): Promise<boolean> => {
	const res = await fetch(`/Charge`, {
		method: 'PATCH',
		body: JSON.stringify(charge),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};
